import { render } from "./OrderCreateSolarSimple.vue?vue&type=template&id=79d7065f"
import script from "./OrderCreateSolarSimple.vue?vue&type=script&lang=js"
export * from "./OrderCreateSolarSimple.vue?vue&type=script&lang=js"

import "./OrderCreateSolarSimple.vue?vue&type=style&index=0&id=79d7065f&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__